import { useRef } from "react";

export default function TiltImage({ src, alt, className = "", testid }) {
    const ref = useRef(null);

    const onMove = (e) => {
        const rect = ref.current.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width - 0.5;
        const py = (e.clientY - rect.top) / rect.height - 0.5;
        ref.current.style.transform = `perspective(1000px) rotateX(${(-py * 7).toFixed(2)}deg) rotateY(${(px * 7).toFixed(2)}deg) scale(1.02)`;
    };
    const onLeave = () => {
        ref.current.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
    };

    return (
        <div
            ref={ref}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            data-testid={testid}
            className="transition-transform duration-200 ease-out will-change-transform"
        >
            <img src={src} alt={alt} className={className} />
        </div>
    );
}
